<template>
  <a :href="mapUrl" target="_blank" class="flex-none hover:bg-gray-20" :aria-label="$t('branch_list.map')">
    <svg-icon :name="props.icon" />
  </a>
</template>

<script setup lang="ts">
import type { EtgButtonProps } from '@/types/component'
import type { IconName } from '@/types/icon'

interface Props {
  address: string
  placeId?: string
  icon: IconName
  iconSize?: EtgButtonProps['size']
}

const props = defineProps<Props>()

const mapUrl = computed(() => {
  const googleMapUrl = new URL('https://www.google.com/maps/search/')
  const searchParams = new URLSearchParams({
    api: '1',
    query: props.address,
  })

  if (props.placeId) {
    searchParams.set('query_place_id', props.placeId)
  }

  googleMapUrl.search = searchParams.toString()

  return googleMapUrl.href
})
</script>
